module.exports = __webpack_public_path__ + "img/2024-09-19e_2.f57a5a6f.jpg";